import { z } from 'zod';
const FinancialPOABaseResponseSchema = z.object({
    id: z.string().uuid(),
    pdfUrl: z.string().url(),
    expiresAt: z.number().int().positive(),
});
export const FinancialPOAGenerationResponseSchema = FinancialPOABaseResponseSchema;
export const FinancialPOADocumentContextResponseSchema = FinancialPOABaseResponseSchema;
const ShareRecipientSchema = z.object({
    role: z.enum(['principal', 'agent', 'other']),
    email: z.string().email(),
    name: z.string().trim().min(1).optional(),
});
export const ShareRequestSchema = z.object({
    docId: z.string().uuid(),
    url: z
        .string()
        .url()
        .refine((value) => value.startsWith('https://'), {
        message: 'Document link must use HTTPS.',
    }),
    recipients: z
        .array(ShareRecipientSchema)
        .min(1, 'Select at least one recipient.')
        .max(5, 'You can send the document to at most five recipients.'),
    message: z
        .string()
        .trim()
        .max(500, 'Message must be 500 characters or fewer.')
        .optional(),
});
export const ShareResponseSchema = z.object({
    id: z.string().uuid(),
    results: z.array(z.object({
        email: z.string().email(),
        status: z.enum(['SENT', 'FAILED']),
        error: z.string().trim().optional(),
    })),
});
export const SharePreviewResponseSchema = z.object({
    html: z.string().min(1),
});
//# sourceMappingURL=api.js.map